var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.693,
    height: 8.983,
    viewBox: "0 0 12.693 8.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "credit-card",
    d: "M11.633.927H1.06A1.014,1.014,0,0,0,0,1.89V8.948a1.014,1.014,0,0,0,1.06.962H11.633a1.014,1.014,0,0,0,1.06-.962V1.89a1.014,1.014,0,0,0-1.06-.962ZM1.192,1.89H11.5a.127.127,0,0,1,.132.12v.842H1.06V2.01A.127.127,0,0,1,1.192,1.89ZM11.5,8.948H1.192a.127.127,0,0,1-.132-.12V5.419H11.633V8.828A.127.127,0,0,1,11.5,8.948ZM4.231,6.943v.8a.254.254,0,0,1-.264.241H2.38a.254.254,0,0,1-.264-.241v-.8A.254.254,0,0,1,2.38,6.7H3.966A.254.254,0,0,1,4.231,6.943Zm4.231,0v.8a.254.254,0,0,1-.264.241h-3a.254.254,0,0,1-.264-.241v-.8A.254.254,0,0,1,5.2,6.7h3A.254.254,0,0,1,8.462,6.943Z",
    transform: "translate(0 -0.927)",
    fill: "#8298ab"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.ddb93fe9.svg";
export { ForwardRef as ReactComponent };